import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Alert, AlertTitle, Snackbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useOfflineContext } from "../../context/Offline";
import { useReceptionistPhone } from "../../lib/hooks/useQueryBoard";

const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  right: 0,
  bottom: 0,
  left: 0,
  [theme.breakpoints.up("sm")]: {
    right: 0,
    bottom: 0,
    left: 0,
  },
}));

const OfflineAlert = () => {
  const { t } = useTranslation(["offline"]);

  const { pathname } = useLocation();
  const { online } = useOfflineContext();
  const receptionistPhone = useReceptionistPhone();

  const isRoot = pathname === "/";

  return (
    <StyledSnackbar open={!(online || !isRoot)} sx={{ right: 0, bottom: 0, left: 0 }}>
      <Alert severity="error" sx={{ "& .MuiAlert-icon": { fontSize: "8rem" } }}>
        <AlertTitle sx={{ fontSize: "5rem" }}>{t("offline:title")}</AlertTitle>
        <Typography variant="h2">{t("offline:receptionMessage")}</Typography>
        {receptionistPhone && (
          <Typography variant="h2">
            {t("offline:check", { receptionistPhone })}
          </Typography>
        )}
      </Alert>
    </StyledSnackbar>
  );
};

export default OfflineAlert;
